import React, { Component } from "react";
import "./OpenRound.css";
import { Link } from "react-router-dom";
import star from "../../../../assets/images/icons/star-icon.png";
import StarRoundIcon from '@mui/icons-material/Star';

const OpenRound = ({ img, header, text, link }) => {
  return (
    <div className="hospital_open_round">
      <div className="imgAndText">
        <img className="openRoundImg" src={img} alt="aa" />
        <div className="openRoundText">
          <h1 className="openRoundTextH">{header}</h1>
          <span className="starSection">
            <StarRoundIcon className="starImg" />
            {/* <img className="starImg" src={star} alt="aa" /> */}
            <p>4.6 (1435 ביקורות)</p>
          </span>
        </div>
      </div>
      <div className="hospitalsbtn">
        <Link className="choose" to={"/web/page/hospital"}>
          {/* <img
            className="openSquareBtn"
            src="/images/hospitals/choose.png"
            alt="aa"
          /> */}
          פתחי
        </Link>
      </div>
    </div>
  );
};

export default OpenRound;
